"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navDivider = navDivider;
exports.default = exports.defaultProps = void 0;

var _unitUtils = _interopRequireDefault(require("@bootstrap-styled/utils/lib/unitUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  '$spacer-y': '1rem'
}; // Horizontal dividers
//
// Dividers (basically an hr) within dropdowns and nav lists

/**
 * @public
 * @description Dividers for certain components (Dropdown, Nav, List, ...).
 * @param {string} spacerY
 * @param {string} dividerColor
 * @returns {string}
 */

exports.defaultProps = defaultProps;

function navDivider() {
  var spacerY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$spacer-y'];
  var dividerColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#e5e5e5';
  var marginY = "".concat(_unitUtils.default.rmUnit(spacerY, _unitUtils.default.UNIT.REM) / 2).concat(_unitUtils.default.UNIT.REM);
  return "\n    height: 1px;\n    margin: calc(".concat(marginY, " / 2) 0;\n    overflow: hidden;\n    background-color: ").concat(dividerColor, ";\n  ");
}

var _default = {
  defaultProps: defaultProps,
  navDivider: navDivider
};
exports.default = _default;